/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Category_ReorderedInputs */

const vi_shop_category_reordered = /** @type {(inputs: Shop_Category_ReorderedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã đổi thứ tự danh mục.`)
};

/**

* @param {Shop_Category_ReorderedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_category_reordered = /** @type {((inputs?: Shop_Category_ReorderedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Category_ReorderedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_category_reordered(inputs)
});